import { Check, LayoutGrid, SlidersHorizontal } from 'lucide-react';
import { ErrorNotice } from '@nw/ui';
import { useHome, useWindowTools } from '@nw/web-platform';
import { WidgetBoard } from '../home/WidgetBoard.js';
import { useHomeEdit } from '../home/homeEdit.js';

/** Homebase is a space of instruments, arranged by you. Swipe its open surface to change space. */
export function HomePage() {
  const home = useHome();
  const { editing, setEditing, setGallery } = useHomeEdit();
  useWindowTools(
    editing
      ? [
          {
            id: 'done',
            label: 'Done',
            icon: Check,
            shortcut: 'e',
            pressed: true,
            run: () => setEditing(false),
          },
          {
            id: 'add-widget',
            label: 'Add widget',
            icon: LayoutGrid,
            run: () => setGallery(true),
          },
        ]
      : [
          {
            id: 'customize',
            label: 'Customize',
            icon: SlidersHorizontal,
            shortcut: 'e',
            run: () => setEditing(true),
          },
        ],
    [editing],
  );
  return (
    <div className="nw-home" data-space-swipe>
      <h1 className="sr-only">Homebase</h1>
      {home.isError ? <ErrorNotice className="mb-6" title="Some of your instruments could not load" detail={home.error.message} onRetry={() => void home.refetch()} /> : null}
      <WidgetBoard />
    </div>
  );
}
